import React, { useEffect } from "react";
import { IlustExercise } from "../../resources/Assets";

//     walking:ILST_WALKING,
//     walkWithPet:ILST_WALKING2,
//     running:ILST_RUNNING,
//     swiming:ILST_SWIMING,
//     mountain:ILST_MOUNTAIN,
//     riding:ILST_RIDING,
//     gym:ILST_GYM,
//     tennis:ILST_TENNIS,
//     squasy:ILST_SQUASY,
//     golf:ILST_GOLF,
//     yoga:ILST_YOGA,
//     pilates:ILST_PILATES,
//     stretching:ILST_STRETCHING

export const TraSubject = (props) => {
    const { exType } = props;
    let exIlust;

    if(exType === 'walking') {
        exIlust = IlustExercise.walking
    } else if(exType === 'walkWithPet') {
        exIlust = IlustExercise.walkWithPet
    } else if(exType === 'running') {
        exIlust = IlustExercise.running
    } else if(exType === 'swiming') {
        exIlust = IlustExercise.swiming
    } else if(exType === 'mountain') {
        exIlust = IlustExercise.mountain
    } else if(exType === 'riding') {
        exIlust = IlustExercise.riding
    } else if(exType === 'gym') {
        exIlust = IlustExercise.gym
    } else if(exType === 'tennis') {
        exIlust = IlustExercise.tennis
    } else if(exType === 'squasy') {
        exIlust = IlustExercise.squasy
    } else if(exType === 'golf') {
        exIlust = IlustExercise.golf
    } else if(exType === 'yoga') {
        exIlust = IlustExercise.yoga
    } else if(exType === 'pilates') {
        exIlust = IlustExercise.pilates
    } else if(exType === 'stretching') {
        exIlust = IlustExercise.stretching
    }

    useEffect(() => {
        console.log(exType);
    }, [exType])

    
    return (
        <div className="tra-subject">
            <div>
                <div className="illust">
                    <div>
                        <img src={exIlust} />
                    </div>
                </div>
            </div>
            <div>
                <div className="tra-info">
                    <span>자전거 타기</span>
                    <p>운동강도 : 빠르게</p>
                    <u>주3회 1시간 30분</u>
                </div>
            </div>
        </div>
    );
};
